/**
 * Firebase initialization file
 * Initializes Firebase app once and exports it for use in other modules
 */
import { FirebaseApp, getApp, getApps, initializeApp } from 'firebase/app';
import { isProduction } from 'utils';

import { firebaseLumiDevConfig, firebaseLumiProdConfig } from './config';

const config = isProduction() ? firebaseLumiProdConfig : firebaseLumiDevConfig;

export const firebaseApp: FirebaseApp = getApps().length === 0 ? initializeApp(config) : getApp();
